import { NotificationRulesService } from "@common/client"
import { notificationPreferencesKey } from "./notifications"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const notificationRulesBaseKey = ["notification-rules"] as const

export const notificationRulesKey = (tenantId: string) =>
  [...notificationRulesBaseKey, tenantId] as const

export const notificationRulesQuery = makeQuery({
  serviceCall: NotificationRulesService.getNotificationRules,
  queryKey: (params) => notificationRulesKey(params.tenant_id),
})

export const workspaceNotificationRulesKey = [
  "workspace-notification-rules",
] as const

export const workspaceNotificationRulesQuery = makeNoArgsQuery({
  serviceCall: NotificationRulesService.listNotificationRules,
  queryKey: workspaceNotificationRulesKey,
})

export const notificationRuleOptionsKey = ["notification-rule-options"] as const

export const notificationRuleOptionsQuery = makeNoArgsQuery({
  serviceCall: NotificationRulesService.getNotificationRuleOptions,
  queryKey: notificationRuleOptionsKey,
})

export const notificationRuleReferenceKey = (tenantId: string) =>
  ["notification-rule-reference", tenantId] as const

export const notificationRuleReferenceQuery = makeQuery({
  serviceCall: NotificationRulesService.getNotificationRuleReference,
  queryKey: (params) => notificationRuleReferenceKey(params.tenant_id),
})

export const useUpdateNotificationRulesMutation = makeAxiosMutation({
  serviceCall: NotificationRulesService.updateNotificationRules,
  invalidates: (params) => [
    notificationRulesKey(params.tenant_id),
    workspaceNotificationRulesKey,
  ],
})

const changedRuleKeys = () => [
  workspaceNotificationRulesKey,
  notificationRulesBaseKey,
  notificationPreferencesKey,
]

export const useCreateNotificationRuleMutation = makeAxiosMutation({
  serviceCall: NotificationRulesService.createNotificationRule,
  invalidates: changedRuleKeys,
})

export const useEditNotificationRuleMutation = makeAxiosMutation({
  serviceCall: NotificationRulesService.editNotificationRule,
  invalidates: changedRuleKeys,
})

export const useDeleteNotificationRuleMutation = makeAxiosMutation({
  serviceCall: NotificationRulesService.deleteNotificationRule,
  invalidates: changedRuleKeys,
})
